import { API_ROOT } from '../../config/config'
import { doGet, doDownload, doPostFiles, doPost, doPut, doDeleteData } from './utils'

// const API_ROOT = 'http://localhost:9016/api'

export const callAuditReportSummary = (year, status, pageNum, pageSize) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/audit/ia/page?year=${year || 0}&status=${status || 0}&pageNum=${pageNum || 0}&pageSize=${pageSize || 0}`
  return doGet(url)
}

export const searchAuditReportSummary = (pageNum, pageSize, request) => {
  const url = `${API_ROOT}/v1/audit/ia/search?pageNum=${pageNum || 0}&pageSize=${pageSize || 0}`
  return doPost(url, request)
}

export const downloadAuditIAp10 = (id, projectVersionId) => {
  const url = `${API_ROOT}/files/iap-10/report?id=${id || ''}&projectVersionId=${
    projectVersionId || ''
  }`
  return doDownload(url)
}

export const saveAuditNotification = (request) => {
  const url = `${API_ROOT}/v1/audit/ia/notification`
  return doPut(url, request)
}

export const processFileImport = (request) => {
  const url = `${API_ROOT}/v1/audit/ia/import/process`
  return doPostFiles(url, request)
}

export const saveDataFromFileImport = (request) => {
  const url = `${API_ROOT}/v1/audit/ia/import/save`
  return doPost(url, request)
}

export const processGradeFileImport = (request) => {
  const url = `${API_ROOT}/v1/audit/ia/import/grade/process`
  return doPostFiles(url, request)
}

export const saveDataFromGradeFileImport = (request) => {
  const url = `${API_ROOT}/v1/audit/ia/import/grade/save`
  return doPost(url, request)
}

export const deleteProjectImportedData = (id) => {
  const url = `${API_ROOT}/v1/audit/ia/import/delete/${id}`
  return doDeleteData(url)
}

export const downloadAuditIAp10word = (id) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/files/download/audit-report/iap-10-word/${id}`
  return doDownload(url)
}

export const onSavefileIAp12 = (request) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/audit/ia/document/save/iap-12`
  return doPostFiles(url, request)
}

export const downloadAuditIAp12Pdf = (filePath) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/audit/download/file?filePath=${filePath}`
  return doDownload(url)
}

export const getAuditIAp12Schema = (id) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/audit/IAp12/file?filePath=${filePath}`
  return doDownload(url)
}
